/* unplugin-vue-components disabled */import script from "./Workspace.vue?vue&type=script&setup=true&lang=js"
export * from "./Workspace.vue?vue&type=script&setup=true&lang=js"

import "./Workspace.vue?vue&type=style&index=0&id=64c5351c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c5351c"]])

export default __exports__